import type { LoggerConfig } from '@frontend/duck-tape';
import { createLoggerFactory } from '@frontend/duck-tape';
import { Env } from './env';

// When you want to add a new scope, add it to here, and the ENABLED_LOGGER_SCOPES array
export type LoggerScope = 'unscoped';

export const ENABLED_LOGGER_SCOPES = ['unscoped'] as const satisfies LoggerScope[];

// Note: Debug logs will only show if your developer tools console filters include them (they don't by default, usually you want to set it to "verbose")
const loggerFactory = createLoggerFactory({
  compactFormat: false,
  defaultLevel: Env.VITE_ENV === 'local' ? 'debug' : 'error',
  enabledScopes: ENABLED_LOGGER_SCOPES,
});

/** Base logger (unscoped) */
export const logger = loggerFactory.logger;

/** Used to create a logger with a strictly typed scope */
export const getScopedLogger = (scope: LoggerScope, config?: Partial<LoggerConfig>) =>
  loggerFactory.getScopedLogger(scope, config);
